import React from "react";
import { Loader2 } from "lucide-react";

export function Spinner({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-[var(--ns-muted)]" data-testid="spinner">
      <Loader2 className="animate-spin" size={20} />
      <span className="text-sm">{label}…</span>
    </div>
  );
}

export function Button({ children, variant = "primary", className = "", ...props }) {
  const base =
    "ns-btn inline-flex items-center justify-center gap-2 font-semibold transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--ns-primary)]";
  const variants = {
    primary: "bg-[var(--ns-primary)] text-white hover:bg-[var(--ns-primary-hover)]",
    outline: "bg-transparent border-2 border-[var(--ns-border)] text-[var(--ns-text)] hover:border-[var(--ns-primary)]",
    ghost: "bg-transparent text-[var(--ns-text)] hover:bg-[var(--ns-surface-subtle)]",
    accent: "bg-[#D96B43] text-white hover:bg-[#c25b35]",
    subtle: "bg-[var(--ns-primary-light)] text-[var(--ns-primary-hover)] hover:brightness-95",
  };
  return (
    <button
      className={`${base} ${variants[variant]} px-5 py-3 rounded-[var(--ns-radius)] ${className}`}
      style={{ minHeight: "var(--ns-touch)" }}
      {...props}
    >
      {children}
    </button>
  );
}

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`ns-card bg-[var(--ns-surface)] border border-[var(--ns-border)] rounded-[var(--ns-radius)] ${className}`} {...props}>
      {children}
    </div>
  );
}

export function Pill({ children, tone = "muted", className = "", ...rest }) {
  const tones = {
    muted: "bg-[var(--ns-surface-subtle)] text-[var(--ns-muted)]",
    gap: "bg-[#FDECE8] text-[#B23A28]",
    mastered: "bg-[#E5F3E8] text-[#1E6B52]",
    gold: "bg-[#FBF0DA] text-[#8A5E15]",
    primary: "bg-[var(--ns-primary-light)] text-[var(--ns-primary-hover)]",
  };
  return (
    <span {...rest} className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${tones[tone]} ${className}`}>
      {children}
    </span>
  );
}
